export type UserNameType =
  | {
      firstName?: string | null;
      lastName?: string | null;
      email: string;
    }
  | null
  | undefined;

export function userName(user: UserNameType): string {
  if (!user) {
    return "";
  }

  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }

  if (user.firstName) {
    return `${user.firstName} (${user.email})`;
  }

  return user.email;
}
